import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import CalendarScheduler from '../components/CalendarSchedular';
import GoogleCalendar from '../components/GoogleCalendar';
import PaymentSection from '../components/PaymentSection';
import './Recommendations.css';
const RecommendationsPage = ({ user, setUser, handleLogout }) => {
    const [recommendations, setRecommendations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasPayment, setHasPayment] = useState(false);
     const apiUrlRootPath = process.env.REACT_APP_API_URL;
     const [appliedUniversities, setAppliedUniversities] = useState(new Set());
     const handleApply = async (universityId) => {
        if (!hasPayment) {
            alert("Please complete payment to apply");
            return;
        }
        
        try {
            const response = await axios.post(`${apiUrlRootPath}/questionnaires/apply-university`, {
                userId: user.id,
                universityId: universityId
            });
            
            if (response.data.success) {
                setAppliedUniversities(prev => new Set([...prev, universityId]));
                alert('Application submitted successfully!');
            }
        } catch (error) {
            console.error('You have already applied to this University :', error);
            alert('You have already applied to this University .');
        }
    };
    useEffect(() => {
        if (hasPayment) {
            Swal.fire({
                title: 'Full Access Unlocked! 🎉',
                text: 'You can now apply to any university of your choice',
                icon: 'success',
                confirmButtonText: 'Let\'s Start!',
                confirmButtonColor: '#1a73e8'
            });
        }
    }, [hasPayment]);
    useEffect(() => {
        const fetchRecommendations = async () => {
            try {
                const response = await axios.get(`${apiUrlRootPath}/questionnaires/recommendations/${user.id}`);
                setRecommendations(response.data.recommendations);
                setHasPayment(response.data.hasPayment);
            } catch (error) {
                console.error('Error fetching recommendations:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchRecommendations();
    }, []);
    // const handlePayment = () => {
    //     const stripePaymentUrl = `https://buy.stripe.com/test_aEUaH63r589s9TqeUV?prefilled_email=${encodeURIComponent(user.email)}&client_reference_id=${user.id}`;
    //     window.location.href = stripePaymentUrl;
    // };
    const styles = {
        recommendationsContainer: {
            padding: '3rem',
            background: 'linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%)',
            borderRadius: '20px',
            boxShadow: '0 20px 50px rgba(0, 0, 0, 0.1)'
        },
        heading: {
            textAlign: 'center',
            color: '#1a73e8',
            marginBottom: '3rem',
            fontSize: '3rem',
            fontWeight: '700',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            background: 'linear-gradient(45deg, #1a73e8, #6a11cb)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
        },
        universitiesGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '2.5rem',
            padding: '1rem',
            perspective: '1000px',

        },
        universityCard: {
            background: 'white',
            borderRadius: '15px',
            padding: '2rem',
            boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.4s ease-in-out',
            transform: 'rotateY(-10deg)',
            transformStyle: 'preserve-3d',
            border: '2px solid transparent',
            backgroundClip: 'padding-box',
            backgroundImage: 'linear-gradient(white, white), linear-gradient(135deg, #1a73e8, #6a11cb)',
            backgroundOrigin: 'border-box',
            backgroundClip: 'content-box, border-box',
            ':hover': {
                transform: 'scale(1.05) rotateY(0)',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)'
            }
        },
        cardHeading: {
            color: '#1a73e8',
            marginBottom: '1.5rem',
            fontSize: '1.8rem',
            fontWeight: '600',
            borderBottom: '2px solid #1a73e8',
            paddingBottom: '0.5rem'
        },
        cardText: {
            color: '#4a4a4a',
            margin: '1rem 0',
            lineHeight: 1.7,
            fontWeight: '300'
        },
        applyButton: {
            background: 'linear-gradient(45deg, #1a73e8, #6a11cb)',
            color: 'white',
            border: 'none',
            padding: '1rem 1.5rem',
            borderRadius: '10px',
            marginTop: '1.5rem',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            width: '100%',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            boxShadow: '0 10px 20px rgba(26, 115, 232, 0.3)',
            ':hover': {
                transform: 'translateY(-5px)',
                boxShadow: '0 15px 30px rgba(26, 115, 232, 0.4)'
            }
        }
    };

    // JavaScript for Tab Interactivity
    const tabs = document.querySelectorAll('.sidebar ul li');
    const contents = document.querySelectorAll('.tab-content');

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            // Remove active class from all tabs and add to clicked tab
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');

            // Hide all content and show the corresponding tab content
            const target = tab.getAttribute('data-tab');
            contents.forEach(content => {
                content.classList.remove('active');
                if (content.id === target) {
                    content.classList.add('active');
                }
            });
        });
    });


    return (
        <>

<div className="dashboard-container">
{/* side bar */}
    <div class="sidebar">
        {/* <div class="logo">Welcome</div> */}
        <ul>
            {/* <li class="active" data-tab="universities-list">
                <i class="fa fa-university" title='Universities List'></i> <span>Universities List</span>
            </li> */}
            <li class="active" data-tab="make-payment">
                <i class="fa fa-money" title='Make Payment'></i> <span>Make Payment</span>
            </li>
            <li data-tab="schedule-appointment">
                <i class="fa fa-calendar" title='Schedule Appointment'></i> <span>Schedule Appointment</span>
            </li>
        </ul>
    </div>




    
    {/* <!-- Main Content --> */}
    <div class="content">
        {/* <!-- Universities List --> */}
        {/* <div id="universities-list" class="tab-content active">
            <h2>Universities List</h2>

            <div style={styles.recommendationsContainer} className="recommendations-container">
            <h3>Your University Recommendations</h3>

                <p class="note">*Note: Please make your payment first. Click on the Make Payment button now and unlock the other features.</p>

            {loading ? (
                    <div>Loading recommendations...</div>
                ) : (
                <div className="universities-grid">
                    {recommendations.map((university) => (
                        <div key={university.id} className="university-card">
                            <h3>{university.name}</h3>
                            <div className={`university-details ${hasPayment !== true ? 'blur-content' : ''}`}>
                                <p>Country: {university.Country.name}</p>
                                <p>Field: {university.FieldOfStudy.name}</p>
                                <p>Annual Fee: {university.Fee.amount} {university.Fee.currency}</p>
                                <p>{university.details}</p>
                                {appliedUniversities.has(university.id) ? (
                                    <div className="success-text">Successfully Applied</div>
                                ) : (
                                    <button
                                        className="apply-button"
                                        onClick={() => handleApply(university.id)}
                                    >
                                        {hasPayment ? 'Apply Now' : 'Unlock Application'}
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
            </div>
            
        </div> */}

        {/* <!-- Make Payment --> */}
        <div id="make-payment" class="tab-content">
            <h2>Make Payment</h2>
            <div class="padding_40">
            {!hasPayment && <>
                    {/* <div className="payment-notice">
                        <h3>Complete payment to apply for Universities and other features</h3>
                    </div> */}
                    <PaymentSection user={user}/>
                    </>
                    }
            </div>
                      
        </div>

        {/* <!-- Schedule Appointment --> */}
        <div id="schedule-appointment" class="tab-content">
            <h2>Schedule Appointment</h2>
            <div class="padding_40">
            <div className={!hasPayment ? 'blur-content' : ''}>
                        <GoogleCalendar />
                    </div>
                    </div>
        </div>

    </div>



            {/* <div style={styles.recommendationsContainer} className="recommendations-container">
                
            <div className="page-container">   
                <div className="left-section">
                
                </div>
                
                <div className="right-section">
                
                </div>
                
                <div className="right-section">

                
                </div>
                </div>
            </div> */}
</div>
        </>

    );
};
export default RecommendationsPage;